// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./header.css";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { logoutAction } from "../../store/actions/auth.action";
// import { ERoutes } from "../../enums/routes";
// import { authSelector } from "../../store/selectors/index";
// import { useSelector } from "react-redux";
// import { getSiteRefrence } from "../../api/endpoints/refrences";

// const SideBar = () => {
//   const { access_token } = useSelector(authSelector);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { pathname } = location;

//   const [open, setOpen] = useState(true);

//   const logout = () => {
//     dispatch(logoutAction());
//     navigate("/");
//   };
//   return (
//     <div
//       className={` ${
//         open ? "w-64" : "w-20 "
//       }  h-screen p-5 navClass  pt-8  relative duration-300  `}
//     >
//       <img
//         src="./assets/control.png"
//         alt=""
//         className={`absolute arrow cursor-pointer -right-3 top-9 w-7
//        border-2 rounded-full  ${!open && "rotate-180"}`}
//         onClick={() => setOpen(!open)}
//       />
//       <Link to="/mainScreen">
//         <div className="flex gap-x-4 items-center">
//           <img
//             src="./assets/logo.png"
//             alt=""
//             className={`cursor-pointer duration-500 ${
//               open && "rotate-[360deg]"
//             }`}
//           />
//           <h1
//             className={`text-white origin-left logoHeading font-medium text-xl duration-200 ${
//               !open && "scale-0"
//             }`}
//           >
//             IT WORLD
//             {/* IT W<span class="braces">&#123;&#125;</span>RLD */}
//           </h1>
//         </div>
//       </Link>
//       <ul className="pt-4">
//         <Link to="/booking">
//           <li
//             className={`flex ${
//               pathname === ERoutes.BOOKING ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Meters.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               BOOKINGS
//             </span>
//           </li>
//         </Link>
//          <Link to="/party">
//           <li
//             className={`flex ${
//               pathname === ERoutes.PARTY ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Meters.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               PARTY
//             </span>
//           </li>
//         </Link>

//         <Link to="/receipts">
//           <li
//             className={`flex ${
//               pathname === ERoutes.RECEIPT ? "bg-blue-500" : ""
//             }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Receipt.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               RECEIPT
//             </span>
//           </li>
//         </Link>
//         <Link to="/payment">
//           <li
//             className={`flex ${
//               pathname === ERoutes.PAYMENT ? "bg-blue-500" : ""
//             }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Payment.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               PAYMENT
//             </span>
//           </li>
//         </Link>

//         {/* <Link to="/bankVoucher">
//           <li
//             className={`flex ${
//               pathname === ERoutes.BANK ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/bank.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               Bank
//             </span>
//           </li>
//         </Link>*/}
//         <Link to="/journalVoucher">
//           <li
//             className={`flex ${
//               pathname === ERoutes.JV ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Ticket.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               JV
//             </span>
//           </li>
//         </Link>
//          <Link to="/daybook">
//           <li
//             className={`flex ${
//               pathname === ERoutes.DAYBOOK ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Ticket.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               DAYBOOK
//             </span>
//           </li>
//         </Link>
//         <Link to="/PLedger">
//           <li
//             className={`flex ${
//               pathname === ERoutes.PLEDGER ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Ticket.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               PARTY LEDGER
//             </span>
//           </li>
//         </Link>
//          <Link to="/chartOfAccount">
//           <li
//             className={`flex ${
//               pathname === ERoutes.CACCOUNT ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Ticket.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               C.ACCOUNT
//             </span>
//           </li>
//         </Link>
//                  <Link to="/GLedger">
//           <li
//             className={`flex ${
//               pathname === ERoutes.GLEDGER ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/Ticket.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               G.LEDGER
//             </span>
//           </li>
//         </Link>

//          <Link to="/eventReport">
//           <li
//             className={`flex  ${
//               pathname === ERoutes.EVENT_REPORT ? "bg-blue-500" : ""
//             } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4
//            mb-1`}
//           >
//             <img src={`./assets/DailySheet.png`} alt="" />
//             <span className={`${!open && "hidden"} origin-left duration-200`}>
//               EVENT REPORT
//             </span>
//           </li>
//         </Link>

//       </ul>
//       <li
//         onClick={logout}
//         className={`flex  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 `}
//       >
//         <img src={`./assets/Logout.png`} alt="" />
//         <span className={`${!open && "hidden"} origin-left duration-200`}>
//           Logout
//         </span>
//       </li>
//     </div>
//   );
// };

// export default SideBar;

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authSelector } from "../../store/selectors";
import { logoutAction } from "../../store/actions/auth.action";
import { ERoutes } from "../../enums/routes";

const SideBar = () => {
  const { access_token } = useSelector(authSelector);
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;

  const [open, setOpen] = useState(true);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);

  const logout = () => {
    dispatch(logoutAction());
  };

  return (
    <div
      className={` ${open ? "w-64" : "w-20 "} h-screen p-5 navClass pt-8 relative duration-300`}
    >
      <img
        src="./assets/control.png"
        alt=""
        className={`absolute arrow cursor-pointer -right-3 top-9 w-7 border-2 rounded-full ${!open && "rotate-180"}`}
        onClick={() => setOpen(!open)}
      />

      {/* Logo */}
      <Link to="/mainScreen">
        <div className="flex gap-x-4 items-center">
          <img
            src="./assets/logo.png"
            alt=""
            className={`cursor-pointer duration-500 ${open && "rotate-[360deg]"}`}
          />
          <h1
            className={`text-white origin-left logoHeading font-medium text-xl duration-200 ${!open && "scale-0"}`}
          >
            IT WORLD
          </h1>
        </div>
      </Link>

      <ul className="pt-4">
        {/* Regular Links */}
        <Link to="/booking">
          <li
            className={`flex ${pathname === ERoutes.BOOKING ? "bg-blue-500" : ""} rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 mb-1`}
          >
            <img src={`./assets/Meters.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              BOOKINGS
            </span>
          </li>
        </Link>

        <Link to="/receipts">
          <li
            className={`flex ${
              pathname === ERoutes.RECEIPT ? "bg-blue-500" : ""
            }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
            mb-1`}
          >
            <img src={`./assets/Receipt.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              RECEIPT
            </span>
          </li>
        </Link>
        <Link to="/payment">
          <li
            className={`flex ${
              pathname === ERoutes.PAYMENT ? "bg-blue-500" : ""
            }  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
            mb-1`}
          >
            <img src={`./assets/Payment.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              PAYMENT
            </span>
          </li>
        </Link>

        <Link to="/journalVoucher">
          <li
            className={`flex ${
              pathname === ERoutes.JV ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
            mb-1`}
          >
            <img src={`./assets/Ticket.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              JV
            </span>
          </li>
        </Link>

        <li
          className={`flex justify-between items-center rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm gap-x-4 mb-1`}
          onClick={() => setAccountOpen(!accountOpen)}
        >
          <div className="flex items-center gap-x-4">
            <img src="./assets/Report.png" alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              ACCOUNTS
            </span>
          </div>
          {open && <span>{accountOpen ? "▲" : "▼"}</span>}
        </li>

        {accountOpen && (
          <ul className="ml-6">
            <Link to="/party">
              <li
                className={`flex ${
                  pathname === ERoutes.PARTY ? "bg-blue-500" : ""
                } rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 
            mb-1`}
              >
                {/* <img src={`./assets/Meters.png`} alt="" /> */}
                <span
                  className={`${!open && "hidden"} origin-left duration-200`}
                >
                  PARTY
                </span>
              </li>
            </Link>

            <Link to="/chartOfAccount">
              <li
                className={`flex ${pathname === ERoutes.CACCOUNT ? "bg-blue-500" : ""} rounded-md p-2 cursor-pointer hover:bg-blue-400 text-white text-sm items-center gap-x-4 mb-1`}
              >
                <span
                  className={`${!open && "hidden"} origin-left duration-200`}
                >
                  C.ACCOUNT
                </span>
              </li>
            </Link>
          </ul>
        )}

        {/* Reports Dropdown */}
        <li
          className={`flex justify-between items-center rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm gap-x-4 mb-1`}
          onClick={() => setReportsOpen(!reportsOpen)}
        >
          <div className="flex items-center gap-x-4">
            <img src="./assets/Report.png" alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              REPORTS
            </span>
          </div>
          {open && <span>{reportsOpen ? "▲" : "▼"}</span>}
        </li>

        {/* Submenu */}
        {reportsOpen && (
          <ul className="ml-6">
            <Link to="/daybook">
              <li
                className={`flex ${pathname === ERoutes.DAYBOOK ? "bg-blue-500" : ""} rounded-md p-2 cursor-pointer hover:bg-blue-400 text-white text-sm items-center gap-x-4 mb-1`}
              >
                <span
                  className={`${!open && "hidden"} origin-left duration-200`}
                >
                  DAYBOOK
                </span>
              </li>
            </Link>
            <Link to="/PLedger">
              <li
                className={`flex ${pathname === ERoutes.PLEDGER ? "bg-blue-500" : ""} rounded-md p-2 cursor-pointer hover:bg-blue-400 text-white text-sm items-center gap-x-4 mb-1`}
              >
                <span
                  className={`${!open && "hidden"} origin-left duration-200`}
                >
                  PARTY LEDGER
                </span>
              </li>
            </Link>
          
            <Link to="/GLedger">
              <li
                className={`flex ${pathname === ERoutes.GLEDGER ? "bg-blue-500" : ""} rounded-md p-2 cursor-pointer hover:bg-blue-400 text-white text-sm items-center gap-x-4 mb-1`}
              >
                <span
                  className={`${!open && "hidden"} origin-left duration-200`}
                >
                  G.LEDGER
                </span>
              </li>
            </Link>
            <Link to="/eventReport">
              <li
                className={`flex ${pathname === ERoutes.EVENT_REPORT ? "bg-blue-500" : ""} rounded-md p-2 cursor-pointer hover:bg-blue-400 text-white text-sm items-center gap-x-4 mb-1`}
              >
                <span
                  className={`${!open && "hidden"} origin-left duration-200`}
                >
                  EVENT REPORT
                </span>
              </li>
            </Link>
          </ul>
        )}
      </ul>

      {/* Logout */}
      <li
        onClick={logout}
        className={`flex rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 mt-5`}
      >
        <img src={`./assets/Logout.png`} alt="" />
        <span className={`${!open && "hidden"} origin-left duration-200`}>
          Logout
        </span>
      </li>
    </div>
  );
};

export default SideBar;
